// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Sz-z","smallCardRow":"Tz-z","largeCardRow":"Uz-z","productSearchRow":"Vz-z","curatedRow":"Wz-z"};